import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import styled from '@emotion/styled';
import { setLocalSignInRedirect } from 'actions/app';
import { getLocalizedPath } from 'helpers/getLocale';

const BODY_FONT = 'Rubik-Regular, system-ui, sans-serif';

const Heading = styled(Typography)({
  fontSize: 26,
  fontWeight: 700,
  textAlign: 'left',
  marginBottom: 14,
  lineHeight: 1.3,
});

const Lede = styled(Typography)(({ theme }) => ({
  fontFamily: BODY_FONT,
  fontSize: 15,
  color: theme.palette.grey[700],
  textAlign: 'left',
  marginBottom: 28,
  lineHeight: 1.6,
}));

const ButtonRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 12,
  '& > *': { flex: 1 },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

const PrimaryButton = styled(Button)({
  fontFamily: BODY_FONT,
  borderRadius: 25,
  padding: '14px 24px',
  fontSize: 16,
  fontWeight: 600,
  textTransform: 'none',
});

const SecondaryButton = styled(Button)(({ theme }) => ({
  fontFamily: BODY_FONT,
  borderRadius: 25,
  padding: '14px 24px',
  fontSize: 15,
  fontWeight: 500,
  textTransform: 'none',
  color: theme.palette.grey[700],
}));

export default function SignUpGate({ redirectTo = '/assessment/consent' }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const setRedirect = () => dispatch(setLocalSignInRedirect(redirectTo));

  const goSignUp = () => { setRedirect(); navigate(getLocalizedPath('/sign-up')); };
  const goSignIn = () => { setRedirect(); navigate(getLocalizedPath('/sign-in')); };

  return (
    <>
      <Heading variant="h1">{t('Assessment.signUpRequiredHeading')}</Heading>
      <Lede>{t('Assessment.signUpRequiredLede')}</Lede>
      <ButtonRow>
        <PrimaryButton variant="contained" color="primary" size="large" onClick={goSignUp}>
          {t('Assessment.signUpRequiredButton')}
        </PrimaryButton>
        <SecondaryButton variant="outlined" size="large" onClick={goSignIn}>
          {t('Assessment.signUpRequiredHaveAccount')}
        </SecondaryButton>
      </ButtonRow>
    </>
  );
}
